var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "filter-or-criteria",
      class: { "filter-inputs-lg": _vm.isFullWidth }
    },
    [
      _c(
        "div",
        { staticClass: "p-r-20 slide-down" },
        [
          _vm.orIndex > 0
            ? _c(
                "div",
                {
                  staticClass: "m-b-10 text-center filter-or-criteria__or-text"
                },
                [
                  _c("strong", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "ROUTER_FILTER_OR",
                        expression: "'ROUTER_FILTER_OR'"
                      }
                    ],
                    staticClass: "m-l-15"
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isReadOnly && _vm.isEditView
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "filter-inputs",
                    class: { "filter-item-geo": _vm.allowMultiselect }
                  },
                  [
                    !_vm.isFullWidth || _vm.isMobileView
                      ? _c("SearchableDropdown", {
                          attrs: {
                            config: _vm.tagsOptions,
                            placeholder: _vm.$t("SELECT_FILTER"),
                            rules: "required"
                          },
                          on: { change: _vm.onTagIdChange },
                          model: {
                            value: _vm.criteriaTag,
                            callback: function($$v) {
                              _vm.criteriaTag = $$v
                            },
                            expression: "criteriaTag"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "ValidationProvider",
                      { attrs: { rules: "required", slim: "" } },
                      [
                        _vm.isFullWidth && !_vm.isMobileView
                          ? _c("TagSelector", {
                              staticClass: "filter-tag-id m-b-8",
                              attrs: {
                                tags: _vm.availableTags,
                                "form-name": _vm.formNameForUserSettings,
                                "search-placeholder": _vm.$t("SEARCH_FILTER"),
                                placeholder: _vm.$t("SELECT_FILTER"),
                                "recently-used-tags": _vm.recentlyUsedTags,
                                "empty-tab-placeholder-text":
                                  "FILTER_SELECTOR_EMPTY_TAB_PLACEHOLDER_TEXT"
                              },
                              on: { change: _vm.onTagSelected },
                              model: {
                                value: _vm.criteriaTag,
                                callback: function($$v) {
                                  _vm.criteriaTag = $$v
                                },
                                expression: "criteriaTag"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("SearchableDropdown", {
                      staticClass: "filter-comparison-type m-b-8",
                      attrs: {
                        config: _vm.comparisonOptions,
                        placeholder: _vm.$t("ROUTER_TAG_COMPARE_PH"),
                        rules: "required"
                      },
                      model: {
                        value: _vm.criteriaComparisonType,
                        callback: function($$v) {
                          _vm.criteriaComparisonType = $$v
                        },
                        expression: "criteriaComparisonType"
                      }
                    }),
                    _vm._v(" "),
                    _vm.criteriaComparisonType.key !== "EXISTS"
                      ? [
                          _vm.showFreeTextInput
                            ? _c("ValidationProvider", {
                                attrs: {
                                  rules: _vm.criteriaValueValidations,
                                  slim: ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors, classes }) {
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.criteriaValue,
                                                expression: "criteriaValue"
                                              }
                                            ],
                                            staticClass:
                                              "form-control filter-criteria-value",
                                            class: classes,
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "ROUTER_VALUE_PH"
                                              ),
                                              type: "text"
                                            },
                                            domProps: {
                                              value: _vm.criteriaValue
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.criteriaValue =
                                                  $event.target.value
                                              }
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1412262260
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showTelInput
                            ? _c("ValidationProvider", {
                                attrs: {
                                  rules: _vm.criteriaValueValidations,
                                  slim: ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors, classes }) {
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.criteriaValue,
                                                expression: "criteriaValue"
                                              }
                                            ],
                                            staticClass:
                                              "form-control filter-criteria-value",
                                            class: classes,
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "ROUTER_VALUE_PH"
                                              ),
                                              type: "tel"
                                            },
                                            domProps: {
                                              value: _vm.criteriaValue
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.criteriaValue =
                                                  $event.target.value
                                              }
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  4234163828
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.allowMultiselect && !_vm.inputIsRange
                            ? _c(
                                "ValidationProvider",
                                { attrs: { rules: "required", slim: "" } },
                                [
                                  _c("MultiSelect", {
                                    staticClass: "filter-or-criteria__value",
                                    class: {
                                      "multi-select-lg": _vm.isFullWidth
                                    },
                                    attrs: {
                                      "show-select-all": "",
                                      "list-items": _vm.prefilledValuesForTag
                                    },
                                    model: {
                                      value: _vm.criteriaValue,
                                      callback: function($$v) {
                                        _vm.criteriaValue = $$v
                                      },
                                      expression: "criteriaValue"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.inputIsRange
                            ? _c("InputMinMax", {
                                attrs: {
                                  "hide-label": "",
                                  "hide-form-group": "",
                                  "class-for-input": "col-md-6",
                                  min: 0,
                                  max: 99999999
                                },
                                model: {
                                  value: _vm.criteriaValue,
                                  callback: function($$v) {
                                    _vm.criteriaValue = $$v
                                  },
                                  expression: "criteriaValue"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.autoFillFilterValues
                            ? _c("SearchableDropdown", {
                                staticClass: "filter-or-criteria__value m-b-8",
                                attrs: {
                                  config: _vm.autoCompleteValuesDropdownConfig,
                                  "numbers-only": _vm.numbersOnly,
                                  rules: "required"
                                },
                                on: { search: _vm.handleValuesSearch },
                                model: {
                                  value: _vm.criteriaValue,
                                  callback: function($$v) {
                                    _vm.criteriaValue = $$v
                                  },
                                  expression: "criteriaValue"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isBoolean
                            ? _c("SearchableDropdown", {
                                staticClass: "filter-or-criteria__value m-b-8",
                                attrs: {
                                  config: {
                                    options: ["yes", "no"],
                                    placeholder: _vm.$t(
                                      "ROUTER_FILTER_VALUE_PH"
                                    )
                                  },
                                  rules: "required"
                                },
                                model: {
                                  value: _vm.criteriaValue,
                                  callback: function($$v) {
                                    _vm.criteriaValue = $$v
                                  },
                                  expression: "criteriaValue"
                                }
                              })
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn btn-function filter-or-criteria__remove",
                    on: {
                      click: function($event) {
                        return _vm.removeRule()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-times" })]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isEditView || _vm.isReadOnly
            ? _c("OrCriteriaSummary", {
                attrs: {
                  criteria: _vm.criteria,
                  "is-read-only": _vm.isReadOnly,
                  "available-tags": _vm.availableTags
                },
                on: { edit: _vm.enableEditView }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }